<template>
  <b-button
    class="delivered-button"
    v-b-tooltip.hover
    title="Mark As Delivered"
  >
    <img src="./delivered.png" alt="" width="25px" class="truck-icon" />
  </b-button>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.truck-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
  fill: rgb(28, 187, 140);
}
.delivered-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
  width: 45px;
  height: 45px;
}
.delivered-button:hover .truck-icon {
  transform: scale(1.3);
}
.delivered-button:hover {
  background-color: rgba(28, 187, 140, 0.1);
}
</style>
